import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { HeaderContainerComponent } from '@kempower-nx-workspace/layout-templates';
import { BrandingService, GetBrandingResult } from '../../data-access/branding.service';

@Component({
    selector: 'rl-core-receipt-header',
    standalone: true,
    imports: [CommonModule, HeaderContainerComponent],
    templateUrl: './receipt-lookup-header.component.html',
    styleUrls: ['./receipt-lookup-header.component.scss'],
})
export class ReceiptLookupHeaderComponent {
    // Define the maximum dimensions for the logo in the header
    logoMaxHeight = 50;
    logoMaxWidth = '100%'; // Full width of the parent container
    logoError = false;

    readonly #brandingService = inject(BrandingService);

    // Keep these - they'll work with the shared service instance
    brandingState = toSignal(this.#brandingService.brandingState$, {
        initialValue: { loading: false } as GetBrandingResult,
    });

    logoUrl = computed(() => {
        this.brandingState();
        return this.#brandingService.getLogoUrl() || '';
    });

    onLogoError(): void {
        this.logoError = true;
    }
}
